import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AspenUserOrgListService, Auth0UserOrganizationsDTO } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const useUserOrgList = () => {
    const [organizations, setOrganizations] = useState<Auth0UserOrganizationsDTO | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const fetchOrganizations = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<Auth0UserOrganizationsDTO> = AspenUserOrgListService.getUserOrganizationsIdentityOrganizationsGet()
            const data = await response
            setOrganizations(data)
        } catch (err) {
            setError('Failed to fetch organization list')
            enqueueSnackbar('Failed to fetch organization list', { variant: 'error' })
        } finally {
            setLoading(false)
        }
    }, [enqueueSnackbar])

    useEffect(() => {
        fetchOrganizations()
    }, [fetchOrganizations])

    return {
        organizations,
        loading,
        error,
        fetchOrganizations
    }
}
